import api from './api'

const resource = '/apps/categories'

export default {
    get() {
        return api.get(`${resource}`);
    }
}